import React from "react";
import i18n from "i18next";
import backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";

i18n
    .use(backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: true,
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json`,
        },
        lng: "fr", // if you're using a language detector, do not define the lng option
        fallbackLng: "en",

        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });

